import React, {PureComponent} from 'react';
import {withStyles} from 'material-ui/styles';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import HousecallLogo from "../Icons/HousecallIcon.js.jsx";
import { isBlank } from 'utils/isBlank';

const styles = theme => ({
    chipBackground: {
        backgroundColor: theme.palette.pro[500],
    },
    chipIcon: {
        backgroundColor: theme.palette.pro['A700'],
    },
    chipLabel: {
        color: '#ffffff'
    },
});

@withStyles(styles)
export default class ProAppChip extends PureComponent {

    render() {
        const {classes} = this.props;

        let label = this.props.label;
        if (isBlank(label)) {
            label = "Housecall pro"
        }

        return <Chip
            avatar={
                <Avatar className={classes.chipIcon}>
                    <HousecallLogo style={{width: 20}} color="#ffffff"/>
                </Avatar>
            }
            label={label}
            className={`${classes.chipBackground} ${this.props.className}`}
            classes={{label: classes.chipLabel}}
        />
    }
}
